/**
 * NFeStatusBadge Component
 * 
 * Componente para exibir badge de status de NF-e.
 * 
 * Status disponíveis:
 * - draft: Rascunho
 * - saved: Salvo/Finalizado (após "Finalizar Venda")
 * - transmitted: Transmitida (após "Transmitir Nota")
 * - cancelled: Cancelada
 * - error: Erro na transmissão (rejeitada pela SEFAZ)
 */

import { FileCheck, XCircle, FileText, AlertCircle } from 'lucide-react'
import './NFeStatusBadge.css'

function NFeStatusBadge({ status }) {
  const statusConfig = {
    draft: { 
      label: 'Rascunho', 
      className: 'status-draft', 
      icon: FileText 
    },
    saved: { 
      label: 'Salvo', 
      className: 'status-saved', 
      icon: FileCheck 
    },
    transmitted: { 
      label: 'Transmitida', 
      className: 'status-transmitted', 
      icon: FileCheck 
    },
    cancelled: { 
      label: 'Cancelada', 
      className: 'status-cancelled', 
      icon: XCircle 
    },
    error: { 
      label: 'Erro', 
      className: 'status-error', 
      icon: AlertCircle 
    }
  }

  const config = statusConfig[status] || { 
    label: status || 'Desconhecido', 
    className: 'status-default', 
    icon: FileCheck 
  }
  const Icon = config.icon

  return (
    <span className={`nfe-status-badge ${config.className}`}>
      <Icon size={14} />
      {config.label}
    </span>
  )
}

export default NFeStatusBadge
